<template>
  <AppCarousel
    v-if="carousel"
    :enabled="mobile"
    :autoplay="4000"
    :class="{ 'flex gap-7': !mobile }"
    pause-autoplay-on-hover
    wrap-around
    pagination
  >
    <Slide v-for="{ src, title, alt, description } in items" :key="title">
      <div class="text-center equal">
        <AppImg :src :alt />
        <h4>{{ title }}</h4>
        <p v-if="description" v-html="description" />
      </div>
    </Slide>
  </AppCarousel>

  <div v-else class="wrapper flex gap-7 pt-8">
    <div
      v-for="{ src, title, alt, description } in items"
      :key="title"
      class="item equal"
    >
      <AppImg :src :alt class="ms-3 mb-1" />
      <h4>{{ title }}</h4>
      <p v-if="description" v-html="description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Slide } from 'vue3-carousel';

interface Item {
  src: string;
  alt: string;
  title: string;
  description?: string;
}

defineProps<{
  items: Item[];
  carousel?: boolean;
}>();

const { mobile } = useBreakpoints();
</script>

<style scoped lang="scss">
.wrapper {
  img {
    max-width: 70px;
  }
  p, h4 {
    padding-inline-start: var(--space-5);
  }
  h4 {
    position: relative;
  }
  h4::after {
    content: "";
    position: absolute;
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: rgb(var(--v-theme-tertiary));
  }

  @media (max-width: 850px) {
    flex-direction: column;
    padding-top: var(--space-6) !important;
  }
}
</style>